import { Redirect } from "expo-router";

/** Alter Pfad. Das Formular liegt unter /auth/forgot. */
export default function LegacyResetPassword() {
  return <Redirect href="/auth/forgot" />;
}
